import App from '@/App.vue';
import Vue from 'vue';
import router from '@/lib/router';
import store from '@/lib/store';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import demoHelper from "@/components/demo/DemoHelper";

Vue.config.productionTip = false;

// Vuetify
Vue.use(Vuetify);

// I18n
Vue.use(VueI18n);
const currentLocale = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : 'en';
const messages = {
    zh: require('@/i18n/zh-CN.json'),
    ru: require('@/i18n/ru.json'),
    ro: require('@/i18n/ro.json'),
    pt: require('@/i18n/pt-BR.json'),
    nl: require('@/i18n/nl.json'),
    ko: require('@/i18n/ko.json'),
    ja: require('@/i18n/ja.json'),
    fr: require('@/i18n/fr.json'),
    es: require('@/i18n/es.json'),
    en: require('@/i18n/en.json'),
    de: require('@/i18n/de.json'),
    da: require('@/i18n/da.json')
};
export const i18n = new VueI18n({
  locale: currentLocale,
  messages,
});

Vue.use(demoHelper);

/**
 * Default date formatter. Usage: {{dateString | formatDate("MM/DD/YYYY")}}
 * If no format is added, the default format is used: MM/DD/YYYY hh:mm
 * A fallback value can be added that will be returned when the value is null/undefined/empty
 */
Vue.filter('formatDate', (value: string, format?: string, fallbackValue?: string) => {
  if (value) {
    return moment(value).format(format ? format : "MM/DD/YYYY hh:mm");
  }
  return fallbackValue;
});

/**
 * Global functions
 */
Vue.mixin({
  methods: {
    userHasRole(authorities: string[]) {
      // Check if the user has the given role
      return (
        this.$store.getters.getUser &&
        this.$store.getters.getUser.authorities &&
        this.$store.getters.getUser.authorities.some((r: string) => authorities.includes(r))
      );
    },
    userHasAuth() {
      // Check if the user is authenticated
      return (
        this.$store.getters.getUser &&
        this.$store.getters.getUser.authorities
      );
    }
  }
});

new Vue({
  store,
  router,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi',
    },
    theme: {
      dark: true,
      themes: {
        dark: {
          primary: "#f15c22",
          accent: "#f15c22",
        }
      }
    },
    lang: {
      t: (key, ...params) => i18n.t(key, params) as string,
    },
  }),
  i18n,
  render: (h) => h(App),
}).$mount('#app');
